(() => {
  if (window.productCardQuickBuyTwoStageInitialized) return;
  window.productCardQuickBuyTwoStageInitialized = true;
  const desktop = window.matchMedia('(min-width: 700px) and (hover: hover) and (pointer: fine)');
  const getCard = (element) => element instanceof Element ? element.closest('.product-card') : null;
  const getQuickBuy = (card) => card.querySelector('[data-product-card-quick-buy]');
  const hasTags = (card) => Boolean(card.querySelector('.product-card-paula-badge, .product-card-tags--inside'));
  const height = (element) => element ? Math.max(element.getBoundingClientRect().height, element.offsetHeight, element.scrollHeight, 0) : 0;
  function setStage(card, stage) {
    if (!desktop.matches || !hasTags(card)) return;
    const quickBuy = getQuickBuy(card);
    if (!quickBuy) return;
    card.style.setProperty('--product-card-quick-buy-compact-height', `${Math.ceil(height(quickBuy.querySelector('.product-card__quick-add-button')))}px`);
    if (stage === 'expanded') {
      const expanded = Math.ceil(Math.max(height(quickBuy.querySelector('.quick_size_view')), height(quickBuy.querySelector('.product-size-hover-grid'))));
      card.style.setProperty('--product-card-quick-buy-expanded-height', `${expanded}px`);
    }
    card.setAttribute('data-quick-buy-stage', stage);
  }
  document.addEventListener('pointerover', (event) => {
    if (!desktop.matches) return;
    const card = getCard(event.target);
    if (!card || !hasTags(card)) return;
    const quickBuy = getQuickBuy(card);
    if (!quickBuy) return;
    const previous = event.relatedTarget;
    if (!previous || !card.contains(previous)) setStage(card, 'compact');
    if (quickBuy.contains(event.target) && (!previous || !quickBuy.contains(previous))) setStage(card, 'expanded');
  });
  document.addEventListener('pointerout', (event) => {
    if (!desktop.matches) return;
    const card = getCard(event.target);
    if (!card || !hasTags(card)) return;
    const quickBuy = getQuickBuy(card);
    if (!quickBuy) return;
    const next = event.relatedTarget;
    if (quickBuy.contains(event.target) && (!next || !quickBuy.contains(next)) && next && card.contains(next)) setStage(card, 'compact');
    if (!next || !card.contains(next)) card.removeAttribute('data-quick-buy-stage');
  });
})();
